
































































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class KapatilanDaireler extends Vue {
  kayitlar: any[] = [];
  yukleniyor: boolean = false;
  islemdeki: number | null = null;
  hata: string = "";
  arama: string = "";

  basliklar = [
    { text: "Id", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "Şehir", value: "sehir.isim" },
    { text: "UYAP Birim Kimliği", value: "uyap_birim_id" },
    { text: "İşlemler", value: "actions", sortable: false },
  ];

  created() {
    this.yukle();
  }

  async yukle() {
    this.yukleniyor = true;
    this.hata = "";
    try {
      const yanit = await this.$http.get(this.$store.state.icwApiUrl + 'admin/kapatilan-daireler');
      this.kayitlar = Array.isArray(yanit.data) ? yanit.data : [];
    } catch (e) {
      this.hata = this.hataMesaji(e, "Liste okunamadı.");
    } finally {
      this.yukleniyor = false;
    }
  }

  async geriAl(item: any) {
    this.islemdeki = item.id;
    this.hata = "";
    try {
      await this.$http.post(
          this.$store.state.icwApiUrl + 'admin/kapatilan-daireler/' + item.id + '/geri-al',
          { data: {}, sendJson: true }
      );
      this.kayitlar = this.kayitlar.filter((r: any) => r.id !== item.id);
      this.$emit('degisti');
    } catch (e) {
      this.hata = this.hataMesaji(e, "İşaret kaldırılamadı.");
    } finally {
      this.islemdeki = null;
    }
  }

  hataMesaji(e: any, varsayilan: string): string {
    const sunucu = e && e.response && e.response.data ? e.response.data.message : null;
    return sunucu || (e && e.message) || varsayilan;
  }
}
